import { Controller } from '@hotwired/stimulus';

// Turbo may apply broadcasts out of order; remember the furthest chunk count per import run.
const maxCompleted = new Map<string, number>();

export default class extends Controller {
  static targets = ['bar', 'chunks'];
  static values = { key: String, completed: Number, total: Number };

  declare readonly barTarget: HTMLProgressElement;
  declare readonly hasBarTarget: boolean;
  declare readonly chunksTarget: HTMLElement;
  declare readonly hasChunksTarget: boolean;
  declare keyValue: string;
  declare completedValue: number;
  declare totalValue: number;

  connect(): void {
    const seen = maxCompleted.get(this.keyValue) || 0;

    if (this.completedValue >= seen) {
      maxCompleted.set(this.keyValue, this.completedValue);
      return;
    }

    const completed = Math.min(seen, this.totalValue);
    if (this.hasBarTarget) this.barTarget.value = completed;
    if (this.hasChunksTarget) {
      this.chunksTarget.textContent = `Chunks ${completed} / ${this.totalValue}`;
    }
  }
}
